// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.tag-button_tag-button_Lm1LH {
    padding: .625rem 1rem;
    background: var(--looks-secondary);
    border-radius: 1.375rem;
    color: white;
    height: 2.5rem;
}

.tag-button_tag-button-icon_iFHFX {
    max-width: 1rem;
    max-height: 1rem;
}

.tag-button_active_uwCfT {
    background: var(--data-primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/tag-button/tag-button.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,qBAAqB;IACrB,kCAAkC;IAClC,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.tag-button {\n    padding: .625rem 1rem;\n    background: var(--looks-secondary);\n    border-radius: 1.375rem;\n    color: white;\n    height: 2.5rem;\n}\n\n.tag-button-icon {\n    max-width: 1rem;\n    max-height: 1rem;\n}\n\n.active {\n    background: var(--data-primary);\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `tag-button_tag-button_Lm1LH`;
export { _1 as "tag-button" };
export var tagButton = `tag-button_tag-button_Lm1LH`;
var _2 = `tag-button_tag-button-icon_iFHFX`;
export { _2 as "tag-button-icon" };
export var tagButtonIcon = `tag-button_tag-button-icon_iFHFX`;
export var active = `tag-button_active_uwCfT`;
export default ___CSS_LOADER_EXPORT___;
